import { StyleSheet } from "react-native";

import {
  skaleBlue,
  skaleSecondaryBlue,
  skaleBlack,
  skaleRed,
  skaleDarkGray,
  skaleLightGray,
  skaleMainBlue,
  skaleWebFillGray,
  skaleWhite,
  skaleWebFillStormy,
  skaleWebTextLightGray,
  skaleBorderLightGray,
  colorWithOpacity,
  skaleBackgroundGray,
  upduoPrimaryDark,
  upduoMediumLightGray,
} from "config/UpduoColors";

export default StyleSheet.create({
  activityHeading: {
    fontWeight: "bold",
    fontSize: 16,
    marginRight: 5,
  },

  sessionStepCardLabel: {
    position: "absolute",
    top: -1,
    left: -1,
    paddingVertical: 5,
    paddingHorizontal: 10,
    backgroundColor: skaleMainBlue,
    borderBottomRightRadius: 10,
    alignItems: "center",
    justifyContent: "center",
  },

  arrowBaseStyle: {
    width: 0,
    height: 0,
    backgroundColor: "transparent",
    borderStyle: "solid",
    borderLeftWidth: 5,
    borderRightWidth: 5,
    borderLeftColor: "transparent",
    borderRightColor: "transparent",
  },

  floatingButton: {
    width: 80,
    height: 38,
    borderRadius: 19,
    alignItems: "center",
    justifyContent: "center",
    elevation: 5,
    shadowRadius: 2,
    shadowColor: colorWithOpacity(skaleBlack, 0.8),
    shadowOpacity: 0.3,
    shadowOffset: {
      width: 1,
      height: 1,
    },
  },

  dropdown: {
    paddingHorizontal: 20,
    height: 34,
    borderWidth: 1,
    borderRadius: 5,
    borderColor: skaleWebFillStormy,
    backgroundColor: skaleWhite,
    marginTop: 10,
    marginHorizontal: 20,
  },

  groupingDivider: {
    height: 1,
    backgroundColor: skaleLightGray,
    alignSelf: "stretch",
  },

  mainButtonContainer: {
    alignItems: "center",
    borderRadius: 15,
    justifyContent: "center",
  },

  navigationBar: {
    zIndex: 0,
    flexDirection: "row",
    alignItems: "center",
    height: 80,
    paddingHorizontal: 30,
    backgroundColor: "white",
    shadowColor: "black",
    shadowOffset: { width: 0, height: 5 },
    shadowRadius: 20,
    shadowOpacity: 0.1,
  },

  subNavigationBar: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: 8,
    paddingLeft: 20,
    paddingRight: 50,
    height: 100,
  },

  pageNavButton: {
    color: skaleBlue,
    fontWeight: "bold",
  },

  profileDetail: {
    width: 42,
    height: 42,
    borderRadius: 20,
    borderColor: skaleWebTextLightGray,
    borderWidth: 1,
  },

  rating: {
    width: 35,
    paddingVertical: 3,
    height: 25,
    marginLeft: 10,
    borderRadius: 5,
    alignItems: "center",
    justifyContent: "center",
  },

  routeHeaderContainer: {
    paddingVertical: 30,
    backgroundColor: skaleWhite,
  },

  subHeaderContainer: {
    flexDirection: "row",
    zIndex: -10,
  },

  routeBodyContainer: {
    flex: 1,
    paddingTop: 30,
    paddingHorizontal: 30,
    zIndex: 0,
  },

  routeDetail: {
    color: "gray",
  },

  routeHeading: {
    fontSize: 24,
  },

  searchInput: {
    height: 34,
    borderWidth: 1,
    borderColor: skaleWebFillStormy,
    borderRadius: 5,
    paddingVertical: 5,
    paddingLeft: 40,
    fontFamily: "ObjectSans-Regular",
    fontSize: 16,
    outlineColor: skaleSecondaryBlue,
    backgroundColor: skaleWhite,
  },

  skillRoleHeading: {
    flexDirection: "row",
    alignItems: "center",
    paddingBottom: 32,
  },

  skillInput: {
    borderWidth: 1,
    borderColor: skaleDarkGray,
    borderRadius: 8,
    paddingVertical: 5,
    paddingHorizontal: 15,
    backgroundColor: skaleWhite,
    marginBottom: 5,
    fontFamily: "ObjectSans-Regular",
    fontSize: 16,
    height: 40,
  },

  skillTitleInput: {
    borderWidth: 1,
    borderColor: skaleDarkGray,
    borderRadius: 8,
    paddingVertical: 5,
    paddingHorizontal: 15,
    backgroundColor: skaleWhite,
    marginBottom: 5,
    fontFamily: "ObjectSans-Regular",
    fontSize: 16,
    height: 40,
  },

  descriptionInput: {
    borderWidth: 1,
    borderColor: skaleDarkGray,
    borderRadius: 8,
    paddingHorizontal: 15,
    backgroundColor: skaleWhite,
    marginBottom: 5,
    height: 200,
    cursor: "text",
  },

  emailBodyInput: {
    borderWidth: 1,
    borderColor: skaleDarkGray,
    paddingHorizontal: 15,
    paddingVertical: 10,
    backgroundColor: skaleWhite,
    marginBottom: 5,
    height: 300,
    cursor: "text",
  },

  textInput: {
    borderRadius: 8,
    borderWidth: 1,
    borderColor: upduoPrimaryDark,
    height: 30,
    paddingHorizontal: 8,
    width: 330,
    backgroundColor: skaleWhite,
    fontSize: 16,
    fontFamily: "ObjectSans-Regular",
  },

  textInputHeader: {
    marginTop: 15,
    paddingVertical: 5,
    fontWeight: "bold",
    fontSize: 18,
  },

  titleLetter: {
    fontSize: 16,
    fontWeight: "300",
    fontFamily: "ObjectSans-Regular",
    color: skaleWhite,
  },

  mainOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 12,
  },

  recordDetailBar: {
    height: 25,
    flexDirection: "row",
    alignItems: "center",
    marginLeft: 20,
    width: 50,
    paddingRight: 5,
  },

  recordDot: {
    width: 12,
    height: 12,
    borderRadius: 6,
    backgroundColor: skaleRed,
    marginRight: 5,
  },

  chatButtonsGroup: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 10,
    marginRight: 10,
  },

  chatExitButtonContainer: {
    alignItems: "center",
    paddingTop: 10,
    height: 50,
    width: 50,
    borderRadius: 25,
    backgroundColor: "transparent",
    borderWidth: 1,
    borderColor: skaleWebFillGray,
  },

  floatingCard: {
    backgroundColor: skaleWhite,
    shadowColor: skaleBlack,
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    elevation: 4,
    borderRadius: 4,
  },

  warningText: {
    fontSize: 14,
    color: skaleRed,
    marginTop: 3,
  },

  thumbnailSmallPhotoSquared: {
    width: 40,
    height: 40,
    borderRadius: 8,
    overflow: "hidden",
  },

  /* RATING */

  ratingButtonContainer: {
    minWidth: 100,
    justifyContent: "center",
    padding: 10,
    borderRadius: 15,
  },

  /* AFTER-SUMMIT DASHBOARD */

  titleText: {
    color: skaleWebTextLightGray,
    fontFamily: "ObjectSans-Medium",
    fontSize: 15,
    marginBottom: 5,
  },

  webtitleText: {
    color: "#333333",
    fontFamily: "ObjectSans",
    fontSize: 14,
    marginBottom: 20,
  },

  descriptionText: {
    color: skaleBlack,
    fontFamily: "ObjectSans-Medium",
    fontSize: 20,
    marginBottom: 30,
  },

  descriptionText2: {
    color: skaleBlack,
    fontFamily: "ObjectSans-Medium",
    fontSize: 16,
    marginBottom: 16,
  },

  titleEditText: {
    color: skaleWebTextLightGray,
    fontFamily: "ObjectSans-Medium",
    fontSize: 15,
    marginTop: 10,
    marginBottom: 12,
  },

  tableHeaderText: {
    color: upduoMediumLightGray,
    fontSize: 14,
    textTransform: "uppercase",
  },

  tableCell40: {
    minHeight: 40,
    justifyContent: "center",
  },

  /* SETTINGS */

  settingsInput: {
    height: 48,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: skaleBorderLightGray,
    padding: 16,
    fontSize: 16,
    backgroundColor: skaleBackgroundGray,
    color: skaleWebTextLightGray,
    fontFamily: "ObjectSans-Regular",
    boxSizing: "border-box",
  },

  /* Session Proceed Modal */

  modalTitleText: {
    fontWeight: "bold",
    fontSize: 24,
    lineHeight: 32,
    textAlign: "center",
  },
});
